const breakpoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 992,
    lg: 1200,
    xl: 1536,
  },
};

export default breakpoints;
